import type { AnyAction, Middleware } from 'redux';
import { CALL_NOTIFICATION } from '../../actions/actionTypes/trainer';
import { CALL_NOTIFICATION_DURATION } from '../../../constants/appRuntime';

let callNotificationTimeout: ReturnType<typeof setTimeout> | undefined;

function getEventName(payload: unknown): string {
    if (typeof payload === 'object' && payload !== null && 'eventName' in payload) {
        const value = (payload as { eventName?: unknown }).eventName;
        return typeof value === 'string' ? value : '';
    }
    return '';
}

const trainerMiddleware: Middleware = store => next => (action: AnyAction) => {
    const { type, payload } = action;

    switch (type) {
        case CALL_NOTIFICATION: {
            if (getEventName(payload) && !callNotificationTimeout) {
                callNotificationTimeout = setTimeout(() => {
                    store.dispatch({
                        type: CALL_NOTIFICATION,
                        payload: {
                            remove: true
                        }
                    });
                    callNotificationTimeout = undefined;
                }, CALL_NOTIFICATION_DURATION);
            }
            break;
        }
        default:
    }

    return next(action);
};

export default trainerMiddleware;
